/* FRANTIC STUDIO · Grauer Studiogrund fuer Produktbilder
   Prueft jedes geladene Produktbild am Rand: hat der Rand genug rein weisse
   Pixel, ist es ein Freisteller auf weissem Studiogrund (auch Hand und
   Modelfotos auf Weiss). Dann bekommt das Bild die Klasse fs-wb und sein
   Rahmen die Klasse fs-wb-tile. CSS faerbt den Rahmen grau und das Bild
   per Farbfilter so um, dass sein Weiss genau dieses Grau wird. Szenenfotos haben keinen
   weissen Rand und bleiben unveraendert. Das Ergebnis wird pro Bild im
   sessionStorage gemerkt, damit beim Weiterklicken nichts neu gerechnet wird. */
(function () {
  'use strict';
  /* Die grosse Bildergalerie auf der Produktseite bleibt bewusst weiss.
     Grau werden Produktkarten, Warenkorb (Seitenleiste und Warenkorbseite),
     Suche und Mega Menue. */
  var SCOPE = [
    '.product-item',
    '.cart-item',
    '.cart-items',
    '.cart-form__items',
    '.product-quick-view',
    '.quick-view',
    '.predictive-search',
    '.search-results'
  ].join(',');
  var EXCLUDE = '#logo, #logo-sticky, .logo-img, .add-to-cart, .fs-seal, .product-gallery, .product-gallery-item, [class*="loox"], [id*="loox"], .payment-icons, .fs-no-tile';
  var KEY = 'fs-wb1:';
  var SIZE = 32;

  /* Farbfilter statt Ueberblenden (mix-blend-mode)
     Frueher wurde das Bild per multiply auf das Grau gelegt. Safari auf dem
     iPhone ueberblendet aber nicht, wenn das Bild in einem wischbaren
     Slider sitzt (Produktkarten): das Bild blieb weiss. Jetzt faerbt ein
     Filter das Bild selbst um, ganz ohne Ueberblenden:
     1. fs-tile-f: jeder Farbkanal wird 10 % heller und dann mit dem Grau
        #e9e6e6 multipliziert. Reines Weiss wird so exakt das Kachelgrau,
        das Produkt bleibt so hell wie im Original. Ergebnis wie vorher,
        nur in jedem Browser gleich.
     2. fs-white-f: fast weisse Pixel (ab 245) werden reines Weiss. Fuer die
        4 Siegel auf der Startseite, deren Bilddateien einen minimal grauen
        Grund haben. Das Rot der Siegel bleibt unveraendert.
     Beide rechnen ausdruecklich im sRGB Farbraum. Safari rechnet einfache
     CSS Filter wie brightness() sonst in einem anderen Farbraum, darum
     reichte dort die bisherige Aufhellung um 1,5 % nicht. */
  var TABLE_R = '0 0.0101 0.0201 0.0302 0.0402 0.0503 0.0603 0.0704 0.0804 0.0905 0.1005 0.1106 0.1206 0.1307 0.1407 0.1508 0.1608 0.1709 0.1809 0.191 0.201 0.2111 0.2211 0.2312 0.2412 0.2513 0.2613 0.2714 0.2814 0.2915 0.3015 0.3116 0.3216 0.3317 0.3417 0.3518 0.3618 0.3719 0.3819 0.392 0.402 0.4121 0.4221 0.4322 0.4422 0.4523 0.4623 0.4724 0.4824 0.4925 0.5025 0.5126 0.5227 0.5327 0.5428 0.5528 0.5629 0.5729 0.583 0.593 0.6031 0.6131 0.6232 0.6332 0.6433 0.6533 0.6634 0.6734 0.6835 0.6935 0.7036 0.7136 0.7237 0.7337 0.7438 0.7538 0.7639 0.7739 0.784 0.794 0.8041 0.8141 0.8242 0.8342 0.8443 0.8543 0.8644 0.8744 0.8845 0.8945 0.9046 0.9137 0.9137 0.9137 0.9137 0.9137 0.9137 0.9137 0.9137 0.9137 0.9137';
  var TABLE_GB = '0 0.0099 0.0198 0.0298 0.0397 0.0496 0.0595 0.0695 0.0794 0.0893 0.0992 0.1091 0.1191 0.129 0.1389 0.1488 0.1587 0.1687 0.1786 0.1885 0.1984 0.2084 0.2183 0.2282 0.2381 0.248 0.258 0.2679 0.2778 0.2877 0.2976 0.3076 0.3175 0.3274 0.3373 0.3473 0.3572 0.3671 0.377 0.3869 0.3969 0.4068 0.4167 0.4266 0.4365 0.4465 0.4564 0.4663 0.4762 0.4862 0.4961 0.506 0.5159 0.5258 0.5358 0.5457 0.5556 0.5655 0.5755 0.5854 0.5953 0.6052 0.6151 0.6251 0.635 0.6449 0.6548 0.6647 0.6747 0.6846 0.6945 0.7044 0.7144 0.7243 0.7342 0.7441 0.754 0.764 0.7739 0.7838 0.7937 0.8036 0.8136 0.8235 0.8334 0.8433 0.8533 0.8632 0.8731 0.883 0.8929 0.902 0.902 0.902 0.902 0.902 0.902 0.902 0.902 0.902 0.902';
  var TABLE_W = '0 0.01 0.02 0.03 0.04 0.05 0.06 0.07 0.08 0.09 0.1 0.11 0.12 0.13 0.14 0.15 0.16 0.17 0.18 0.19 0.2 0.21 0.22 0.23 0.24 0.25 0.26 0.27 0.28 0.29 0.3 0.31 0.32 0.33 0.34 0.35 0.36 0.37 0.38 0.39 0.4 0.41 0.42 0.43 0.44 0.45 0.46 0.47 0.48 0.49 0.5 0.51 0.52 0.53 0.54 0.55 0.56 0.57 0.58 0.59 0.6 0.61 0.62 0.63 0.64 0.65 0.66 0.67 0.68 0.69 0.7 0.71 0.72 0.73 0.74 0.75 0.76 0.77 0.78 0.79 0.8 0.81 0.82 0.83 0.84 0.85 0.86 0.87 0.88 0.89 0.9 0.91 0.92 0.93 0.94 0.95 0.9667 0.9833 1 1 1';
  function injectFilters() {
    if (document.getElementById('fs-tile-filters') || !document.body) return !!document.getElementById('fs-tile-filters');
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('id', 'fs-tile-filters');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
    function filter(id, r, g, b) {
      var f = document.createElementNS(ns, 'filter');
      f.setAttribute('id', id);
      f.setAttribute('color-interpolation-filters', 'sRGB');
      f.setAttribute('x', '0'); f.setAttribute('y', '0');
      f.setAttribute('width', '1'); f.setAttribute('height', '1');
      f.setAttribute('filterUnits', 'objectBoundingBox');
      var ct = document.createElementNS(ns, 'feComponentTransfer');
      [['feFuncR', r], ['feFuncG', g], ['feFuncB', b]].forEach(function (c) {
        var fn = document.createElementNS(ns, c[0]);
        fn.setAttribute('type', 'table');
        fn.setAttribute('tableValues', c[1]);
        ct.appendChild(fn);
      });
      f.appendChild(ct);
      svg.appendChild(f);
    }
    filter('fs-tile-f', TABLE_R, TABLE_GB, TABLE_GB);
    filter('fs-white-f', TABLE_W, TABLE_W, TABLE_W);
    document.body.appendChild(svg);
    /* Erst jetzt duerfen CSS Regeln auf die Filter verweisen */
    document.documentElement.classList.add('fs-svgf');
    return true;
  }

  function store(k, v) { try { sessionStorage.setItem(KEY + k, v); } catch (e) {} }
  function recall(k) { try { return sessionStorage.getItem(KEY + k); } catch (e) { return null; } }

  function srcOf(img) { return img.currentSrc || img.src || ''; }
  function keyOf(src) { return src.split('?')[0].replace(/^https?:/, ''); }
  function sameOrigin(src) {
    try { return new URL(src, location.href).origin === location.origin; } catch (e) { return false; }
  }

  /* Gemessen an allen 194 Produktbildern des Shops: Szenenfotos haben 0 bis
     1 % rein weisse Randpixel, Freisteller mindestens 8 %. Schwelle 6 %.
     Jede Pruefung bekommt eine eigene kleine Leinwand: eine Leinwand, auf
     die einmal ein fremdes Bild gezeichnet wurde, bleibt sonst fuer immer
     gesperrt und alle weiteren Pruefungen schlagen fehl. */
  function whiteEdged(source) {
    var c = document.createElement('canvas');
    c.width = c.height = SIZE;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0, SIZE, SIZE);
    var d = ctx.getImageData(0, 0, SIZE, SIZE).data;
    var white = 0, total = 0, last = SIZE - 2;
    for (var y = 0; y < SIZE; y++) {
      for (var x = 0; x < SIZE; x++) {
        if (x > 1 && x < last && y > 1 && y < last) continue;
        var i = (y * SIZE + x) * 4;
        var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        total++;
        if (a < 20 || (mn >= 246 && mx - mn <= 8)) white++;
      }
    }
    return white / total >= 0.06;
  }

  function mark(img, wb) {
    if (wb && !injectFilters()) wb = false;
    img.classList.remove('fs-wb', 'fs-photo');
    var box = img.parentElement;
    if (wb) {
      img.classList.add('fs-wb');
      if (box) box.classList.add('fs-wb-tile');
    } else {
      img.classList.add('fs-photo');
      if (box) box.classList.remove('fs-wb-tile');
    }
  }

  /* Fremde Domain (z. B. cdn.shopify.com im Warenkorb): kleine Kopie mit
     CORS laden und diese pruefen. Klappt das nicht, bleibt das Bild wie es ist. */
  function checkRemote(img, src, k) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var wb = whiteEdged(probe);
        store(k, wb ? '1' : '0');
        if (srcOf(img) === src) mark(img, wb);
      } catch (e) {}
    };
    probe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=64';
  }

  function check(img) {
    var src = srcOf(img);
    if (!src || img.__fsSrc === src) return;
    if (!img.closest(SCOPE) || img.closest(EXCLUDE)) return;
    if (src.indexOf('data:') === 0 || /\.svg(\?|$)/i.test(src)) return;
    var k = keyOf(src);
    var cached = recall(k);
    if (cached !== null) { img.__fsSrc = src; mark(img, cached === '1'); return; }
    if (!sameOrigin(src)) { img.__fsSrc = src; checkRemote(img, src, k); return; }
    if (!img.complete || !img.naturalWidth) return;
    img.__fsSrc = src;
    try {
      var wb = whiteEdged(img);
      store(k, wb ? '1' : '0');
      mark(img, wb);
    } catch (e) {}
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('img');
    for (var i = 0; i < list.length; i++) check(list[i]);
  }

  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') check(t);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { injectFilters(); scan(); });
  } else { injectFilters(); scan(); }
  window.addEventListener('load', function () { scan(); });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].addedNodes;
      for (var j = 0; j < n.length; j++) {
        if (n[j].nodeType !== 1) continue;
        if (n[j].tagName === 'IMG') check(n[j]); else if (n[j].querySelector) scan(n[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
